<template>
  <div class="about">
    <div class="banner">
      <img src="/img/banner.ccb23fe3.png" alt="" />
      <div class="info">
        <p class="row1">我们期待您的加入!</p>
        <p>每一项工作都各不相同，每一天都各有精彩!</p>
      </div>
    </div>

    <div class="section" style="margin-top: 62px">
      <h3>我们</h3>
      <div class="content video-content" style="margin-top: 22px">
        <div class="text-left">
          <p>北京瑞奥视科技有限公司成立于2006年，注册资金1673.33万元。拥有专业的技术团队，专注于流媒体技术的创新和运用，定位为"移动互联网开发及运营服务商"；</p>
          <p>瑞奥视公司总部设于北京，主管商务合作、市场营销、项目统筹管理、客户服务等工作；北京设有研发运营中心，主要负责技术研发、产品运营、系统运维等工作；</p>
          <p>公司经营范围包括广播电视节目制作、技术服务、计算机系统服务、基础软件服务、应用软件服务以及数据处理等；</p>
          <p>本公司是一家专门致力于为中国主流媒体机构在移动互联网垂直市场提供技术开发，应用软件开发、 内容审核、内容风控等及开发与运营一体的综合性服务企业。</p>
        </div>
        <div class="video-right" :class="{ pause: pause }">
          <div class="video-mask" v-if="pause" @click="playPlayer">
            <img src="/img/video.1e1ae9f0.png" alt="" />
          </div>
          <video
            ref="video"
            src="http://resstatic.today365.com.cn/site/video/45bc9efdd5d62a95b0558d07a6ea163f.mp4"
            :poster="'/img/video.1e1ae9f0.png'"
            :controls="!pause"
            webkit-playsinline="true"
            playsinline="true"
            x-webkit-airplay="allow"
            x5-playsinline
            @play="onPlayerPlay"
            @pause="onPlayerPause"
          ></video>
        </div>
      </div>
    </div>

    <div class="section" style="margin-top: 40px">
      <h3>资质</h3>
      <div class="content" style="margin-top: 30px">
        <p>《信息网络传播视听许可证》、《增值电信业务经营许可证》、《网络视听节目审核员》持证人员多名</p>
        <p>应用市场、微剧、媒体号、小程序、广告平台、数据平台接入的必须资质。</p>
        <p>《视听许可证》含"手机等手机终端设备"，小程序、APP业务备案必要条件。</p>
        <p>"其他微短剧"（总投资额低于30万元且非重点推荐的微短剧）内容审核把关与版权核定，发放瑞网平台备案号。自2024年6月1日起，未经审核且备案的微短剧不得上网传播。</p>
      </div>
    </div>

    <div class="section service-section" style="margin-top: 44px; padding-top: 66px">
      <div class="service">
        <h3>主营业务</h3>
        <div class="content service-list">
          <div class="service-list-item">
            <img src="/img/service-icon1.png" alt="" />
            <p>互联网全平台运营技术合作+系统集成</p>
          </div>
          <div class="service-list-item">
            <img src="/img/service-icon2.png" alt="" />
            <p>网络视听内容制作、播出等相关业务<br />（网络影视剧、微短剧等）</p>
          </div>
          <div class="service-list-item">
            <img src="/img/service-icon1.png" alt="" />
            <p>境外影视剧引进<br /><span style="margin-left: -4px">（具有合规额度）</span></p>
          </div>
        </div>
      </div>
    </div>

    <div class="section partner" style="margin-top: 40px">
      <div class="partner-title">合作伙伴</div>
      <div class="partner-list">
        <div class="partner-list-item" v-for="(img, index) in partnerList" :key="index">
          <img :src="img" />
        </div>
      </div>
    </div>

    <div class="section join" style="margin-top: 72px; margin-bottom: 100px">
      <ul class="join-left">
        <li>
          <h5>加入我们</h5>
          <div class="cont">
            <p>我们期待您的加入! 每一项工作都各不相同，每一天都各有精彩!</p>
            <p>邮箱：fenglei@today365.com.cn</p>
          </div>
        </li>
        <li>
          <h5>商务合作</h5>
          <div class="cont">
            <p>开放创新 资源互补 共赢发展!</p>
            <p>邮箱：zhaidan@today365.com.cn</p>
          </div>
        </li>
        <li>
          <h5>联系我们</h5>
          <div class="cont">
            <p>邮箱：ruiaoshi@today365.com.cn</p>
            <p>我们在这里：北京石景山国广公寓9层</p>
          </div>
        </li>
      </ul>
      <div class="join-right">
        <img src="/img/map.f229cda5.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      partnerList: [
        '/img/国广控股.5988dd99.png',
        '/img/中国文旅.2e844603.png',
        '/img/CIBN.ecab3bfc.png',
        '/img/优酷logo.944bbf6e.png',
        '/img/欢喜首映.177b4acb.png',
        '/img/NBA.6756739b.png',
        '/img/华数传媒logo.629c649e.png',
        '/img/华视网聚.c88316e9.png',
        '/img/森宇文化.7f5fe207.png',
        '/img/华动高车.669a37ac.png'
      ],
      pause: true
    }
  },
  methods: {
    playPlayer() {
      this.$refs.video.play()
      this.pause = false
    },
    onPlayerPlay() {
      this.pause = false
    },
    onPlayerPause() {
      this.pause = true
    }
  }
}
</script>

<style lang="scss" scoped>
.about {
  .banner {
    width: 100%;
    height: 641px;
    position: relative;
    margin-top: -68px;

    &::after {
      content: "";
      width: 100%;
      height: 446px;
      background: linear-gradient(180deg, #3228d2, rgba(209, 47, 60, 0));
      opacity: 0.3;
      position: absolute;
      top: 641px;
      left: 0;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .info {
      width: 1196px;
      height: auto;
      overflow: hidden;
      position: absolute;
      top: 234px;
      left: 50%;
      transform: translateX(-50%);
      padding-left: 152px;

      p.row1 {
        font-family: PingFang;
        font-weight: 700;
        font-size: 60px;
        color: #fff;
        line-height: 60px;
        margin-bottom: 34px;
      }

      p {
        font-family: PingFang;
        font-size: 38px;
        color: #fff;
        line-height: 38px;
      }
    }
  }

  .section {
    width: 1196px;
    margin: auto;
    height: auto;
    overflow: hidden;

    h3 {
      display: inline-block;
      padding: 0 6px;
      color: #000;
      font-family: PingFang;
      font-weight: 700;
      font-size: 30px;
      line-height: 30px;
      position: relative;

      &::after {
        content: "";
        width: 100%;
        height: 6px;
        background: linear-gradient(90deg, #3029d5, #d62f38);
        border-radius: 3px;
        position: absolute;
        left: 0;
        bottom: -7px;
      }
    }

    .content {
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        font-family: PingFang;
        font-size: 14px;
        color: #000;
        line-height: 30px;
        text-indent: 2em;
      }
    }
  }

  .video-content {
    display: flex;
    gap: 30px;

    .text-left {
      flex: 1;
    }
  }

  .video-right {
    width: 400px;
    flex-shrink: 0;
    position: relative;

    .video-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 1;

      img {
        width: 60px;
        height: 60px;
      }
    }

    video {
      width: 100%;
    }
  }

  .service-section {
    width: 100%;
    height: 365px;
    background: #f8fafc;

    .service {
      width: 1196px;
      height: 100%;
      margin: 0 auto;
    }
  }

  .service-list {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-around;
    margin-top: 48px;
  }

  .service-list-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    &:first-child img {
      width: 78px;
      height: 78px;
      margin-bottom: 5px;
    }

    &:nth-child(2) img {
      width: 80px;
      height: 70px;
      margin-bottom: 15px;
    }

    &:nth-child(3) img {
      width: 80px;
      height: 79px;
      margin-bottom: 6px;
    }

    p {
      font-family: PingFang;
      font-size: 14px;
      color: #000;
      line-height: 30px;
      text-indent: 0 !important;
    }
  }

  .partner {
    position: relative;

    .partner-title {
      width: 598px;
      height: 170px;
      background: #3129d4;
      font-family: PingFang;
      font-weight: 700;
      font-size: 70px;
      color: #fff;
      line-height: 170px;
      text-align: center;
      position: absolute;
      top: 170px;
      left: 299px;
    }

    .partner-list {
      display: flex;
      flex-wrap: wrap;
    }

    .partner-list-item {
      width: 25%;
      height: 170px;
      background: #fff;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;

      &:nth-child(1),
      &:nth-child(3),
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(9) {
        background: #f8fafc;
      }

      &:nth-child(6) {
        margin-left: 598px;
      }

      img {
        width: auto;
        height: 100%;
        margin: 0 auto;
      }
    }
  }

  .join {
    height: auto;
    overflow: hidden;
    display: flex;

    .join-left {
      padding-top: 6px;
      flex: 1;
      list-style: none;
      padding-left: 0;

      li {
        margin-bottom: 32px;

        h5 {
          font-family: PingFang;
          font-weight: 700;
          font-size: 20px;
          color: #000;
          line-height: 20px;
          margin-bottom: 16px;
        }

        .cont p {
          font-family: PingFang;
          font-size: 14px;
          color: #000;
          line-height: 28px;
          text-indent: 0;
        }
      }
    }

    .join-right {
      width: 500px;
      flex-shrink: 0;

      img {
        width: 100%;
      }
    }
  }
}
</style>
